import {Component, computed, inject, OnInit, ViewChild, ElementRef, effect} from '@angular/core';
import Splide from '@splidejs/splide';
import {SliderManagementService} from "../../admin/slider-management/services/slider-management.service";

@Component({
  selector: 'app-login-carousel',
  imports: [],
  templateUrl: './login-carousel.component.html',
  styleUrl: './login-carousel.component.scss'
})

export class LoginCarouselComponent implements OnInit {
  protected CDN = inject('CDN' as any) as string;
  protected slideService = inject(SliderManagementService)

  @ViewChild('splideElement') splideElement!: ElementRef;
  private splideInstance?: Splide;

  constructor() {
    effect(() => {
      const slides = this.activeSlides();
      if (slides.length > 0 && this.splideElement) {
        setTimeout(() => this.initCarousel(), 0);
      }
    });
  }

  private initCarousel() {
    if (this.splideInstance) {
      this.splideInstance.destroy();
    }

    const slides = this.activeSlides();
    const hasSingleSlide = slides.length === 1;

    this.splideInstance = new Splide(this.splideElement.nativeElement, {
      type: hasSingleSlide ? 'fade' : 'loop',
      autoplay: !hasSingleSlide,
      interval: 5000,
      speed: 1300,
      arrows: !hasSingleSlide,
      pagination: !hasSingleSlide,
      direction: 'ltr'
    }).mount();
  }

  activeSlides = computed(() => {
    if (this.slideService.isLoading()) {
      return []
    }

    const slides = this.slideService.slider();
    const now = new Date();

    return slides.filter((slide: { start: string | number | Date; end: string | number | Date; }) => {
      const start = new Date(slide.start);
      const end = new Date(slide.end);
      return now >= start && now <= end;
    }).sort((a: { order: number; }, b: { order: number; }) => a.order - b.order);
  });

  openLink(link: string) {
    window.open(link, '_blank');
  }

  async ngOnInit() {
    await this.slideService.downloadList(false);
  }
}
